import { GetAllData } from 'interfaces/api.interfaces'
import { InnovationTableRow } from 'modules/innovationTable/api'
import { PaginateData } from 'packages/react-query'

export enum InnovationTabsCodes {
  All = 'all',
  Regular = 'regular',
  Archive = 'archive',
}

export type InnovationAllData = Record<InnovationTabsCodes, PaginateData<GetAllData<InnovationTableRow>> | undefined>
